import BillApi from '@/api/bill';
import STATUS from '@/constants/status';
import { METRICS, setMetric, setTags } from '../util/owl';

export default {
  namespaced: true,
  state: {
    customerId: '', // 客户ID
    settleUnitIdList: [], // 结算单元id列表
    currentUnbilledInfo: {}, // 当前选中的未出账单
    currentBilledInfo: {}, // 当前选中的已出账单
    currentPoiBillInfo: {}, // 当前选中的租宝或者售宝门店月账单信息
    currentDayBillInfo: {}, // 当前选中的租宝日账单信息
    hasHistoryBill: false, // 是否有历史账单
  },
  getters: {
    // 是不是受税改影响的账单 (影响门店账单和门店日流水)
    isTaxEffectedBill(state, getters, rootState, rootGetters) {
      const { billMonth, settleUnitMode } = state.currentPoiBillInfo;
      return Number(billMonth) >= 202209 && !rootGetters.isAgentUser && settleUnitMode === 0;
    },
  },
  mutations: {
    setCustomerId(state, customerId) {
      state.customerId = customerId;
      Owl.setDimension({ unionId: customerId });
      setTags('customerId', customerId);
      setMetric(METRICS.HOST_ENV);
    },
    setSettleUnitIdList(state, settleUnitIdList) {
      state.settleUnitIdList = settleUnitIdList;
    },
    setCurrentUnbilledInfo(state, currentUnbilledInfo) {
      state.currentUnbilledInfo = currentUnbilledInfo;
    },
    setCurrentBilledInfo(state, currentBilledInfo) {
      state.currentBilledInfo = currentBilledInfo;
    },
    setCurrentPoiBillInfo(state, currentPoiBillInfo) {
      state.currentPoiBillInfo = currentPoiBillInfo;
    },
    setCurrentDayBillInfo(state, currentDayBillInfo) {
      state.currentDayBillInfo = currentDayBillInfo;
    },
    setHasHistoryBill(state, hasHistoryBill) {
      state.hasHistoryBill = hasHistoryBill;
    },
  },
  actions: {
    // 从大象，开店宝push、站内信跳转过来，需要获取customerId 和 settleUnitIdList
    async getHomeIncome({ commit, state }) {
      const { customerId } = state;
      if (!customerId) { // 从大象端跳转到账单列表页时，需要获取customerId && settleUnitIdList
        const { code, data } = await BillApi.getHomeIncome();
        if (code === STATUS.SUCCESS) {
          commit('setCustomerId', data.customerId);
          commit('setSettleUnitIdList', data.settleUnitIdList);
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    async getBillList({ state, dispatch }, payload) {
      const success = await dispatch('getHomeIncome');
      if (!success) return null;
      await dispatch('fetchAccountType', null, { root: true });
      const params = {
        ...payload,
        customerId: state.customerId,
        settleUnitIdList: state.settleUnitIdList,
      };
      const res = await BillApi.getBillList(params);
      return res;
    },
  },
};
